// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-block {
}

.text-block .text-with-icon-wrapper {
  display: flex;
  flex-direction: row;
}

.text-block .text-with-icon-wrapper .image-container img {
  width: 32px;
  margin: 0 10px 4px 0;
}

.text-block .text-with-icon-wrapper .text {
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
}

.text-block .text-with-icon-wrapper .icon-container {
  margin-right: 10px;
}

.text-block .text-with-icon-wrapper + .undericon-text {
  margin-top: 6px;

  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.text-block.css"],"names":[],"mappings":"AAAA;AACA;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;;EAEf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".text-block {\n}\n\n.text-block .text-with-icon-wrapper {\n  display: flex;\n  flex-direction: row;\n}\n\n.text-block .text-with-icon-wrapper .image-container img {\n  width: 32px;\n  margin: 0 10px 4px 0;\n}\n\n.text-block .text-with-icon-wrapper .text {\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 18px;\n}\n\n.text-block .text-with-icon-wrapper .icon-container {\n  margin-right: 10px;\n}\n\n.text-block .text-with-icon-wrapper + .undericon-text {\n  margin-top: 6px;\n\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
